const thirdParty = {
  thirdParty: {
    pageHeader: 'Rapportage door derden',
    clearState: 'Heldere staat',
    register: 'Registreer',
    systemRegistrationSummary: 'Samenvatting Systeemsregistratie',
    registrationProgress: '%{registration_in_progress} In uitvoering',
    registrationComplete: '%{registration_complete} In uitvoering',
    thirdPartyLogin: 'Log in als locatie beheerder om uw PowerDash-account te beheren',
    thirdPartyInvalidURI: 'De gevraagde URL is ongeldig of de gevraagde bron, zoals een systeem, bestaat niet.'
  }
};

export default thirdParty;
